import { render, staticRenderFns } from "./BaseTwoPagination.vue?vue&type=template&id=71ace8bb"
import script from "./BaseTwoPagination.vue?vue&type=script&lang=js"
export * from "./BaseTwoPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports